// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ccu4C","question":"styles_question__1xWRM","inputVisibleButton":"styles_inputVisibleButton__1N6EG","note":"styles_note__1P3xD"};